import React, { useEffect } from "react";
import { Link } from "react-router-dom";

import flagEnGb from "../../i/flag/lang/en-GB.png";
import flagEnUs from "../../i/flag/lang/en-US.png";
import flagDaDK from "../../i/flag/lang/da-DK.png";
import flagDeDe from "../../i/flag/lang/de-DE.png";
import flagItIt from "../../i/flag/lang/it-IT.png";
import flagNlNl from "../../i/flag/lang/nl-NL.png";
import flagPlPl from "../../i/flag/lang/pl-PL.png";
import flagSvSe from "../../i/flag/lang/sv-SE.png";
import flagPtBr from "../../i/flag/lang/pt-BR.png";
import flagEsEs from "../../i/flag/lang/es-ES.png";
import flagFrFr from "../../i/flag/lang/fr-FR.png";

import { useSelector } from "react-redux";
import { useAppDispatch } from "../../redux/hooks";
import { IRootState } from "../../types/redux/IRootStore";
import { setCulture } from "../../redux/slices/auth.feature";
import i18n from "../../translations/i18n";
import AplSettingsSelector from "../../redux/helpers/AplSettingsSelector";
import { Culture } from "../../types/culture";

export default function LanguageSelector() {
    const aplSettings = AplSettingsSelector();
    const setLanguage = (language: Culture) => {
        dispatch(setCulture(language) as any);
    };

    useEffect(() => {
        i18n.changeLanguage(aplSettings.culture);
    }, [aplSettings.culture]);

    const cultureRedux = useSelector((state: IRootState) => state.auth.culture);
    const dispatch = useAppDispatch();
    const cultureFlag = (culture: string) => {
        if (culture === "en-GB") return flagEnGb;
        if (culture === "da-DK") return flagDaDK;
        if (culture === "de-DE") return flagDeDe;
        if (culture === "it-IT") return flagItIt;
        if (culture === "nl-NL") return flagNlNl;
        if (culture === "pl-PL") return flagPlPl;
        if (culture === "sv-SE") return flagSvSe;
        if (culture === "en-US") return flagEnUs;
        if (culture === "pt-BR") return flagPtBr;
        if (culture === "es-ES") return flagEsEs;
        if (culture === "fr-FR") return flagFrFr;

        return flagEnGb;
    };

    return (
        <React.Fragment>
            <li className="nav-item dropdown">
                <Link
                    className="nav-link active dropdown-toggle"
                    to={""}
                    id="navbarLanguageDropdown"
                    role="button"
                    data-bs-toggle="dropdown"
                    data-toggle="dropdown"
                    aria-expanded="false"
                >
                    {aplSettings.authLoading ? (
                        <div className="spinner-grow spinner-grow-sm" role="status">
                            <span className="sr-only">Loading...</span>
                        </div>
                    ) : (
                        <img src={cultureFlag(cultureRedux)} id="navbarLanguageDropdownImg" alt="Flag" />
                    )}
                </Link>
                <ul
                    id="navbarLanguageDropdownItems"
                    className="dropdown-menu dropdown-menu-sm-left min-width-0"
                    aria-labelledby="navbarDropdown"
                >
                    <li>
                        <Link
                            className="dropdown-item"
                            onClick={() => {
                                setLanguage("en-GB");
                            }}
                            to={""}
                        >
                            <img src={flagEnGb} alt="EN" />
                            &nbsp;English{" "}
                        </Link>
                    </li>
                    <li>
                        <Link
                            className="dropdown-item"
                            onClick={() => {
                                setLanguage("da-DK");
                            }}
                            to={""}
                        >
                            <img src={flagDaDK} alt="DK" />
                            &nbsp;Danish{" "}
                        </Link>
                    </li>
                    <li>
                        <Link
                            className="dropdown-item"
                            onClick={() => {
                                setLanguage("de-DE");
                            }}
                            to={""}
                        >
                            <img src={flagDeDe} alt="DE" />
                            &nbsp;German{" "}
                        </Link>
                    </li>
                    <li>
                        <Link
                            className="dropdown-item"
                            onClick={() => {
                                setLanguage("it-IT");
                            }}
                            to={""}
                        >
                            <img src={flagItIt} alt="IT" />
                            &nbsp;Italian{" "}
                        </Link>
                    </li>
                    <li>
                        <Link
                            className="dropdown-item"
                            onClick={() => {
                                setLanguage("nl-NL");
                            }}
                            to={""}
                        >
                            <img src={flagNlNl} alt="NL" />
                            &nbsp;Dutch{" "}
                        </Link>
                    </li>
                    <li>
                        <Link
                            className="dropdown-item"
                            onClick={() => {
                                setLanguage("pl-PL");
                            }}
                            to={""}
                        >
                            <img src={flagPlPl} alt="PL" />
                            &nbsp;Polish{" "}
                        </Link>
                    </li>
                    <li>
                        <Link
                            className="dropdown-item"
                            onClick={() => {
                                setLanguage("sv-SE");
                            }}
                            to={""}
                        >
                            <img src={flagSvSe} alt="SV" />
                            &nbsp;Swedish{" "}
                        </Link>
                    </li>
                    <li>
                        <Link
                            className="dropdown-item"
                            onClick={() => {
                                setLanguage("en-US");
                            }}
                            to={""}
                        >
                            <img src={flagEnUs} alt="US" />
                            &nbsp;English (US){" "}
                        </Link>
                    </li>
                    <li>
                        <Link
                            className="dropdown-item"
                            onClick={() => {
                                setLanguage("pt-BR");
                            }}
                            to={""}
                        >
                            <img src={flagPtBr} alt="PT" />
                            &nbsp;Portuguese (Brazil){" "}
                        </Link>
                    </li>
                    <li>
                        <Link
                            className="dropdown-item"
                            onClick={() => {
                                setLanguage("es-ES");
                            }}
                            to={""}
                        >
                            <img src={flagEsEs} alt="ES" />
                            &nbsp;Spanish (Spain){" "}
                        </Link>
                    </li>
                    <li>
                        <Link
                            className="dropdown-item"
                            onClick={() => {
                                setLanguage("fr-FR");
                            }}
                            to={""}
                        >
                            <img src={flagFrFr} alt="FR" />
                            &nbsp;French (France){" "}
                        </Link>
                    </li>
                </ul>
            </li>
        </React.Fragment>
    );
}
